"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getOperationsForAccount = exports.getAccountsForPublicKey = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var network_1 = __importDefault(require("../../../network"));
var network_2 = require("./network");
var operation_1 = require("../../../operation");
var sdk_1 = require("@hashgraph/sdk");
var env_1 = require("../../../env");
var utils_1 = require("../utils");
var getMirrorApiUrl = function () { return (0, env_1.getEnv)("API_HEDERA_MIRROR"); };
var fetch = function (path) {
    return (0, network_1["default"])({
        method: "GET",
        url: "".concat(getMirrorApiUrl()).concat(path)
    });
};
function getAccountsForPublicKey(publicKey) {
    return __awaiter(this, void 0, void 0, function () {
        var r, e_1, rawAccounts, accounts, rawAccounts_1, rawAccounts_1_1, raw, accountBalance, e_2_1;
        var e_2, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetch("/api/v1/accounts?account.publicKey=".concat(publicKey, "&balance=false"))];
                case 1:
                    r = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _b.sent();
                    if (e_1.name === "LedgerAPI4xx")
                        return [2 /*return*/, []];
                    throw e_1;
                case 3:
                    rawAccounts = r.data.accounts;
                    accounts = [];
                    _b.label = 4;
                case 4:
                    _b.trys.push([4, 9, 10, 11]);
                    rawAccounts_1 = __values(rawAccounts), rawAccounts_1_1 = rawAccounts_1.next();
                    _b.label = 5;
                case 5:
                    if (!!rawAccounts_1_1.done) return [3 /*break*/, 8];
                    raw = rawAccounts_1_1.value;
                    return [4 /*yield*/, (0, network_2.getAccountBalance)(raw.account)];
                case 6:
                    accountBalance = _b.sent();
                    accounts.push({
                        accountId: sdk_1.AccountId.fromString(raw.account),
                        balance: accountBalance.balance
                    });
                    _b.label = 7;
                case 7:
                    rawAccounts_1_1 = rawAccounts_1.next();
                    return [3 /*break*/, 5];
                case 8: return [3 /*break*/, 11];
                case 9:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 11];
                case 10:
                    try {
                        if (rawAccounts_1_1 && !rawAccounts_1_1.done && (_a = rawAccounts_1["return"])) _a.call(rawAccounts_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/, accounts];
            }
        });
    });
}
exports.getAccountsForPublicKey = getAccountsForPublicKey;
function getOperationsForAccount(ledgerAccountId, address, latestOperationTimestamp) {
    return __awaiter(this, void 0, void 0, function () {
        var operations, r, rawOperations, newOperations, rawOperations_1, rawOperations_1_1, raw, consensus_timestamp, timestamp, senders, recipients, fee, value, type, i, transfer, amount, account, hash;
        var e_3, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    operations = [];
                    return [4 /*yield*/, fetch("/api/v1/transactions?account.id=".concat(address, "&timestamp=gt:").concat(latestOperationTimestamp))];
                case 1:
                    r = _b.sent();
                    rawOperations = r.data.transactions;
                    _b.label = 2;
                case 2:
                    if (!r.data.links.next) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetch(r.data.links.next)];
                case 3:
                    r = _b.sent();
                    newOperations = r.data.transactions;
                    rawOperations.push.apply(rawOperations, __spreadArray([], __read(newOperations), false));
                    return [3 /*break*/, 2];
                case 4:
                    try {
                        for (rawOperations_1 = __values(rawOperations), rawOperations_1_1 = rawOperations_1.next(); !rawOperations_1_1.done; rawOperations_1_1 = rawOperations_1.next()) {
                            raw = rawOperations_1_1.value;
                            consensus_timestamp = raw.consensus_timestamp;
                            timestamp = new Date(parseInt(consensus_timestamp.split(".")[0], 10) * 1000);
                            senders = [];
                            recipients = [];
                            fee = new bignumber_js_1["default"](raw.charged_tx_fee);
                            value = new bignumber_js_1["default"](0);
                            type = "NONE";
                            for (i = raw.transfers.length - 1; i >= 0; i--) {
                                transfer = raw.transfers[i];
                                amount = new bignumber_js_1["default"](transfer.amount);
                                account = sdk_1.AccountId.fromString(transfer.account);
                                if (transfer.account === address) {
                                    if (amount.isNegative()) {
                                        value = amount.abs();
                                        type = "OUT";
                                    }
                                    else {
                                        value = amount;
                                        type = "IN";
                                    }
                                }
                                if (amount.isNegative()) {
                                    senders.push(transfer.account);
                                }
                                else {
                                    if (account.shard.eq(0) && account.realm.eq(0)) {
                                        if (account.num.lt(100)) {
                                            // account is a node, only add to list if we have none
                                            if (recipients.length === 0) {
                                                recipients.push(transfer.account);
                                            }
                                        }
                                        else if (account.num.lt(1000)) {
                                            // account is a system account that is not a node
                                            // do NOT add
                                        }
                                        else {
                                            recipients.push(transfer.account);
                                        }
                                    }
                                    else {
                                        recipients.push(transfer.account);
                                    }
                                }
                            }
                            // NOTE: earlier addresses are the "fee" addresses
                            recipients.reverse();
                            senders.reverse();
                            hash = (0, utils_1.base64ToUrlSafeBase64)(raw.transaction_hash);
                            operations.push({
                                value: value,
                                date: timestamp,
                                // NOTE: there are no "blocks" in hedera
                                // Set a value just so that it's considered confirmed according to isConfirmedOperation
                                blockHeight: 5,
                                blockHash: null,
                                extra: {},
                                fee: fee,
                                hash: hash,
                                recipients: recipients,
                                senders: senders,
                                accountId: ledgerAccountId,
                                id: (0, operation_1.encodeOperationId)(ledgerAccountId, hash, type),
                                type: type
                            });
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (rawOperations_1_1 && !rawOperations_1_1.done && (_a = rawOperations_1["return"])) _a.call(rawOperations_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return [2 /*return*/, operations];
            }
        });
    });
}
exports.getOperationsForAccount = getOperationsForAccount;
//# sourceMappingURL=mirror.js.map